import { render, staticRenderFns } from "./DmTableEmpty.vue?vue&type=template&id=3b092944"
import script from "./DmTableEmpty.vue?vue&type=script&lang=js"
export * from "./DmTableEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports